import React, { useState, useEffect } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Filler } from "chart.js";
import { Line } from "react-chartjs-2";
import ChartColors from '../ChartColors';

ChartJS.register(CategoryScale, Legend, Tooltip, ArcElement, LinearScale, PointElement, LineElement, Filler)

export default function ExtratoComparativoChart(props) {
    const [valores, setValores] = useState(props.valores ? props.valores : []);
    const [labels, setLabels] = useState(["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"])
    const [datasets, setDatasets] = useState([]);

    let datasetCollection = [{}];

    useEffect(() => {
        gerarDadosChart();
    }, []);

    const gerarDadosChart = () => {
        datasetCollection = [];
        const linhas = [];
        let dataset = {};
        valores.map(municipio => {
            let linha = { 'municipio_id': null, 'municipio': null, 'meses': [], 'valorTotal': 0.0000 };

            for (let mes_id = 1; mes_id < 13; mes_id++) {
                municipio.map((valor) => {
                    let mes = { mes_id: mes_id, valor: null };
                    if (valor.mes_id == mes_id) {
                        mes.valor = 0.0000;
                        let floatValor = parseFloat(String(valor.valor).replaceAll('.', '').replaceAll(',', '.'));
                        if (!isNaN(floatValor)) {
                            mes.valor = floatValor
                        }
                        linha.municipio = valor.municipio;
                        linha.municipio_id = valor.municipio_id;
                        linha.meses.push(mes.valor);
                    }
                });
            }
            linhas.push({ municipio: linha.municipio, municipio_id: linha.municipio_id, meses: linha.meses });
        });
        linhas.map((linha, i) => {
            dataset =
            {
                label: linha.municipio,
                data: linha.meses,
                borderColor: ChartColors[i],
                backgroundColor: ChartColors[i],
            };
            datasetCollection.push(dataset);
        });
        setDatasets(datasetCollection);
    }

    const options = {
        responsive: true,
        elements: {
            line: {
                tension: 0.3
            }
        },
        plugins: {
            legend: true,
            title: {
                display: true,
                text: 'Chart.js Line Chart',
            },
        },
    };

    // const options = {
    //     responsive: true,
    //     elements: {
    //         line: {
    //             tension: 0.3
    //         }
    //     },
    //     plugins: {
    //         legend: {
    //             display: true,
    //             position: 'left',
    //             align: 'start',
    //             labels: {
    //                 usePointStyle: true,
    //                 boxWidth: 15
    //             }
    //         },

    //         title: {
    //             display: true,
    //             text: 'Chart.js Line Chart',
    //         },
    //     },
    // };

    return (
        <>
            {datasets &&
                <div className="container-fluid" style={{ marginBottom: '30px', marginTop: '-25px', height: '' }}>
                    <Line options={options} data={{ labels, 'datasets': datasets }} height={45} style={{ minHeight: '150px' }} />
                </div>
            }
        </>
    );

}
